<template>
  <!-- 系统目录 公共目录 -->
  <div class="MedicenCata">
    <!-- main -->
    <div class="main">
      <!-- left -->
      <div class="main-left">
        <!-- tree -->
        <el-tree
            :data="elTree"
            :props="defaultProps"
            node-key="label"
            :default-expanded-keys="['全部']"
            accordion
            @node-click="handleNodeClick"
            class="custom-tree"
        >
					<span class="custom-tree-node" slot-scope="{ node, data }" style="font-size: 12px;">
						<span :name="node.label">
							<i v-if="!data.children"
                 :class="node.expanded ? 'el-icon-openFile' : 'el-icon-closeFiles'"></i>
							<i v-else class="el-icon-openFile"></i>{{ node.label }}
						</span>
					</span>
        </el-tree>
      </div>
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!-- tit -->
        <div class="main-icon">
          <div class="main-icon-c">
            <span
                style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">关键字：</span>
            <el-input size="mini" placeholder="输入名称搜索"
                      v-model="searchValue" clearable @keyup.enter.native="handClick(0)"></el-input>
          </div>
          <!-- btn3 -->
          <div class="main-icon-c">
            <el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini"
                       @click="handClick(i)">{{ v.title }}
            </el-button>
          </div>
        </div>
        <!-- add data -->
        <!-- messagesBox -->
        <!-- table -->
        <div class="table">
          <el-table :data="tableData" border height="70vh" style="width: 100%" @row-click="handleShowRow">
            <template v-for="col in tableRows">
              <el-table-column
                  :key="col.prop"
                  :prop="col.prop"
                  :label="col.name"

                  :width="col.width || undefined"
              >
                <!-- 仅对 type/state 特殊处理，其他字段原样显示 -->
                <template #default="{ row }">
                  <template v-if="col.prop === 'type'">
                    {{ typeMap[row.type] || row.type }} <!-- 类型转换 -->
                  </template>
                  <template v-else-if="col.prop === 'state'">
                    <el-tag :type="row.state === 1 ? 'success' : 'danger'">
                      {{ stateMap[row.state] || row.state }} <!-- 状态转换 + 标签样式 -->
                    </el-tag>
                  </template>
                  <template v-else>
                    {{ row[col.prop] }} <!-- 其他字段直接显示 -->
                  </template>
                </template>
              </el-table-column>
            </template>
            <!-- fixed -->
            <el-table-column fixed="left" label="行号" type="index" align="center"></el-table-column>
            <!-- edit -->
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" :disabled="scope.row.clinicId === 0"
                           v-if="$store.getters.hasPermission('system:docrute:edit')"
                           @click="handleClickEdit(scope.row)">
                  编辑
                </el-button>
                <el-button type="primary" @click="handleClick(scope.row)" size="mini">
                  项目对照
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>


      </div>
    </div>
    <!-- feet -->
    <div class="feet">
      <!-- messagesBox -->
      <div class="messagesBox">
        <el-dialog
            :title="watch"
            :visible.sync="dialogVisible"
            width="40%"
            :before-close="handleClose">
          <!-- messagesBox / tabs -->
          <div class="tabs">
            <el-form :model="contrastItemForm" :inline="true" size="mini" :disabled="true">

              <el-form-item label="" prop="code">
                <span style="width: 68px;margin-right: 2px;font-weight: bold;">名称:</span>
                <el-input v-model="contrastItemForm.name"></el-input>
              </el-form-item>

              <el-form-item label="" prop="status">
                <span style="width: 68px;margin-left: 2px;font-weight: bold;">其他名称:</span>
                <el-input v-model="contrastItemForm.otherName"></el-input>
              </el-form-item>

              <el-form-item class="twoLine" label="" prop="textSpell">
                <span style="width: 50px;margin-left: 2px;font-weight: bold;">类型:</span>
                <el-select v-model="contrastItemForm.type">
                  <el-option label="注射" :value="1"/>
                  <el-option label="输液" :value="2"/>
                  <el-option label="口服" :value="3"/>
                  <el-option label="外用" :value="4"/>
                  <el-option label="输血" :value="5"/>
                  <el-option label="其他" :value="6"/>
                </el-select>
              </el-form-item>

              <el-form-item class="twoLine" label="" prop="textSpell">
                <span style="width: 68px;margin-left: 2px;font-weight: bold;">适用对象:</span>
                <el-select v-model="contrastItemForm.lmtSpc">
                  <el-option
                      v-for="item in applyTargetOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>


            <div class="table-header">
              <el-button-group class="transparent-btn-group">
                <el-button type="" icon="el-icon-plus" size="mini" class="transparent-btn"
                           @click="handleAdd" v-if="$store.getters.hasPermission('system:cosrute:add')"></el-button>
                <el-button type="" icon="el-icon-edit" size="mini" class="transparent-btn" :disabled="!selectedRow"
                           @click="handleEdit" v-if="$store.getters.hasPermission('system:cosrute:edit')"></el-button>
                <el-button type="" icon="el-icon-circle-close" size="mini" class="transparent-btn"
                           :disabled="!selectedRow"
                           @click="handleDelete"
                           v-if="$store.getters.hasPermission('system:cosrute:remove')"></el-button>
              </el-button-group>
            </div>


            <div class="table">
              <el-table :data="tableData2" border
                        @row-click="handleRowClick"
                        highlight-current-row
                        :style="{ width: windowWidth + 'px' }"
                        ref="myTable">
                <template v-for="col in tableRows2">
                  <el-table-column
                      :key="col.prop"
                      :prop="col.prop"
                      :label="col.name"
                      align="center"
                      :formatter="(row) => formatColumn(row, col.prop)"
                  >
                  </el-table-column>
                </template>
                <!-- fixed -->
                <el-table-column fixed="left" label="行号" type="index"></el-table-column>
              </el-table>
            </div>
          </div>
        </el-dialog>


        <div class="tabs">
          <el-dialog
              title="新增"
              :visible.sync="addDialogVisible"
              width="35%"
              :before-close="handleCloseAddRelevance">
            <el-form :model="cosruteAddForm" :inline="true" size="mini">

              <el-form-item label="" prop="code">
                <span style="width: 35px;margin-right: 2px;font-weight: bold;">类别:</span>
                <el-select v-model="cosruteAddForm.type" popper-class="compact-select" style="width: 150px">
                  <el-option
                      v-for="item in typeOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="" prop="status">
                <span style="width: 68px;margin-left: 2px;font-weight: bold;">适用对象:</span>
                <el-select v-model="cosruteAddForm.ruteLmtSpc" popper-class="compact-select" style="width: 150px">
                  <el-option
                      v-for="item in applyTargetOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>

              </el-form-item>

              <el-form-item class="twoLine" label="" prop="textSpell">
                <span style="width: 35px;margin-left: 2px;font-weight: bold;">项目:</span>
                <el-select v-model="cosruteAddForm.costId" style="width: 300px" size="mini"
                           popper-class="compact-select" filterable>
                  <el-option
                      v-for="item in projectOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="twoLine" label="" prop="textSpell">
                <span style="width: 60px;margin-left: 2px;font-weight: bold;">计次方式:</span>
                <el-select v-model="cosruteAddForm.cntType" popper-class="compact-select" style="width: 150px">
                  <el-option
                      v-for="item in countTypeOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="twoLine" label="" prop="textSpell">
                <span style="width: 60px;margin-left: 2px;font-weight: bold;">收费方式:</span>
                <el-select v-model="cosruteAddForm.costType" popper-class="compact-select" style="width: 150px">
                  <el-option
                      v-for="item in costTypeOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="twoLine" label="" prop="textSpell" v-if="cosruteAddForm.costType === 4">
                <span style="width: 60px;margin-left: 2px;font-weight: bold;">收费次数:</span>
                <el-input type='number' v-model="cosruteAddForm.costCnt"
                          @input="handleChargeNumberCorrect"
                          popper-class="compact-select" style="width: 150px">
                </el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
      <el-button @click="handleCloseAddRelevance" size="mini">取 消</el-button>
      <el-button type="primary" @click="handleAddData" size="mini">确 定</el-button>
    </span>
          </el-dialog>
        </div>

        <div class="tabs">
          <el-dialog
              title="修改"
              :visible.sync="editDialogVisible"
              width="35%"
              :before-close="handleClose">
            <el-form :model="cosruteEditForm" :inline="true" size="mini">

              <el-form-item label="" prop="code">
                <span style="width: 35px;margin-right: 2px;font-weight: bold;">类别:</span>
                <el-select v-model="cosruteEditForm.type" popper-class="compact-select" style="width: 150px">
                  <el-option
                      v-for="item in typeOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="" prop="status">
                <span style="width: 68px;margin-left: 2px;font-weight: bold;">适用对象:</span>
                <el-select v-model="cosruteEditForm.ruteLmtSpc" popper-class="compact-select" style="width: 150px">
                  <el-option
                      v-for="item in applyTargetOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>

              </el-form-item>

              <el-form-item class="twoLine" label="" prop="textSpell">
                <span style="width: 35px;margin-left: 2px;font-weight: bold;">项目:</span>
                <el-select v-model="cosruteEditForm.costId" style="width: 300px" size="mini"
                           popper-class="compact-select">
                  <el-option
                      v-for="item in projectOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="twoLine" label="" prop="textSpell">
                <span style="width: 60px;margin-left: 2px;font-weight: bold;">计次方式:</span>
                <el-select v-model="cosruteEditForm.cntType" popper-class="compact-select" style="width: 150px">
                  <el-option
                      v-for="item in countTypeOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="twoLine" label="" prop="textSpell">
                <span style="width: 60px;margin-left: 2px;font-weight: bold;">收费方式:</span>
                <el-select v-model="cosruteEditForm.costType" popper-class="compact-select" style="width: 150px">
                  <el-option
                      v-for="item in costTypeOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
      <el-button @click="editDialogVisible = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="handleEditData" size="mini">确 定</el-button>
    </span>
          </el-dialog>
        </div>
      </div>

      <el-dialog
          :close-on-click-modal="false"
          :title="cosruteTitel"
          :visible.sync="addCosruteDialogVisible"
          width="50%"
          @close="handleCloseAddCosrute"
          class="responsive-dialog"
      >
        <el-form
            ref="cosruteFormRef"
            :model="cosruteForm"
            :rules="cosruteFormRules"
            label-position="right"
            size="mini"
            class="responsive-form"
        >
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item label="编码" prop="code">
                <el-input v-model="cosruteForm.code" placeholder="自动生成" disabled/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item label="名称" prop="name">
                <el-input v-model="cosruteForm.name" @input="handleConvertingPinyin" placeholder="请输入名称"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item label="是否执行" prop="exeB">
                <el-select v-model="cosruteForm.exeB" placeholder="请选择" style="width:100%">
                  <el-option label="否" :value="0"/>
                  <el-option label="是" :value="1"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item label="状态">
                <el-select v-model="cosruteForm.state" placeholder="请选择" style="width:100%">
                  <el-option label="禁用" :value="0"/>
                  <el-option label="启用" :value="1"/>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行 -->
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item label="给药方式类型" prop="type">
                <el-select v-model="cosruteForm.type" placeholder="请选择" style="width:100%" @change="handleSelCode">
                  <el-option label="注射" :value="1"/>
                  <el-option label="输液" :value="2"/>
                  <el-option label="口服" :value="3"/>
                  <el-option label="外用" :value="4"/>
                  <el-option label="输血" :value="5"/>
                  <el-option label="其他" :value="6"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item label="适用对象">
                <el-select v-model="cosruteForm.lmtSpc" placeholder="请选择" style="width:100%">
                  <el-option
                      v-for="item in applyTargetOptions"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item label="修改数量">
                <el-input-number
                    v-model="cosruteForm.modifyCnt"
                    :min="0"
                    controls-position="right"
                    style="width:100%"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
              <el-form-item label="显示顺序">
                <el-input-number
                    v-model="cosruteForm.orderId"
                    :min="0"
                    controls-position="right"
                    style="width:100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第三行 -->
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="其他名称">
                <el-input v-model="cosruteForm.otherName" placeholder="请输入其他名称"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="拼音简码">
                <el-input v-model="cosruteForm.pyCode" placeholder="输入名称自动生成" disabled/>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 备注单独一行 -->
          <el-form-item label="备注">
            <el-input
                v-model="cosruteForm.remark"
                type="textarea"
                :rows="2"
                placeholder="请输入备注信息"
            />
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="addCosruteDialogVisible = false">取消</el-button>
          <el-button size="mini" type="primary" @click="addCosruteForm">确定</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>/

<script>
import {
  addCosrute,
  addCosruteForm,
  deleteCosrute,
  editCosruteForm,
  getChargingPrice,
  getCosrute,
  getCosruteItemData,
  getMedicationFrequency,
  updateCosrute
} from "@/api/cosrute/Cosrute";
import { pinyin } from "pinyin-pro";
import { withLoading } from "@/untils/loading";
import { dict } from "@/api/staff/staff";

// 工厂函数：生成空的给药方式表单
const getEmptyCosruteForm = () => ({
  code: '',
  exeB: 1,
  name: '',
  type: null,
  lmtSpc: 0,
  modifyCnt: 0,
  orderId: 0,
  otherName: '',
  pyCode: '',
  remark: '',
  state: 1
});

// 工厂函数：生成空的项目对照新增表单
const getEmptyCosruteAddForm = () => ({
  costId: null,
  ruteId: null,
  cntType: 0,
  costCnt: null,
  costType: 1,
  dosUnt: '',
  dpurcId: null,
  drugGrpsum: null,
  drugId: null,
  feeType: null,
  frquId: null,
  id: null,
  lmtDrug: null,
  costName: '',
  type: 1,
  ruteLmtSpc: 0
});

// 工厂函数：生成空的项目对照编辑表单
const getEmptyCosruteEditForm = () => ({
  costId: null,
  ruteId: null,
  cntType: 0,
  costCnt: null,
  costType: 1,
  dosUnt: '',
  dpurcId: null,
  drugGrpsum: null,
  drugId: null,
  feeType: null,
  frquId: null,
  id: null,
  lmtDrug: null,
  costName: '',
  type: 1,
  ruteLmtSpc: 0
});

// 工具函数：生成拼音简码
const generatePinyinCode = (name) => {
  if (!name) return '';
  return pinyin(name, {
    pattern: 'first',
    toneType: 'none',
    separator: ''
  }).toLocaleUpperCase();
};

export default {
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      selectedRow: null,
      watch: '查看',
      searchValue: '',
      CatalogueName: '',
      DropDownedName: '可用',
      iconComes: 'el-icon-dangan',
      loading: false,
      dialogVisible: false,
      addDialogVisible: false,
      addCosruteDialogVisible: false,
      cosruteTitel: '',
      editDialogVisible: false,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,
      typeSelect: null,
      windowWidth: '',

      // 表单数据
      cosruteForm: getEmptyCosruteForm(),
      cosruteEditForm: getEmptyCosruteEditForm(),
      cosruteAddForm: getEmptyCosruteAddForm(),
      contrastItemForm: {
        id: null,
        name: '',
        otherName: '',
        type: '',
        lmtSpc: ''
      },

      // 校验规则
      cosruteFormRules: {
        exeB: [{ required: true, message: '请选择是否执行', trigger: 'change' }],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在1到100个字符', trigger: 'blur' }
        ],
        type: [{ required: true, message: '请选择给药类型', trigger: 'change' }]
      },

      // 下拉选项
      projectOptions: [],
      typeOptions: [{ id: 1, label: '项目' }, { id: 2, label: '材料' }],
      applyTargetOptions: [
        { id: 0, label: '全部' },
        { id: 1, label: '西药' },
        { id: 2, label: '中药' },
        { id: 3, label: '卫材' }
      ],
      countTypeOptions: [
        { id: 0, label: '频率计次' },
        { id: 1, label: '数量计次' }
      ],
      costTypeOptions: [
        { id: 1, label: '不限' },
        { id: 2, label: '首次' },
        { id: 3, label: '续次1' },
        { id: 4, label: '固定次数' },
        { id: 5, label: '医嘱首次' },
        { id: 6, label: '次日起计费' }
      ],

      // 映射表
      typeMap: {
        1: '注射', 2: '输液', 3: '口服', 4: '外用', 5: '输血', 6: '其他'
      },
      stateMap: {
        0: '禁用', 1: '可用'
      },

      // 按钮配置
      headerBtn: [
        { search: "search", title: "搜索", type: "success" },
        { add: "add", title: "新增", type: "warning", auth: 'system:docrute:add' }
      ],

      // 表格列配置
      tableRows: [
        { name: "系统序号", prop: "id", width: 70 },
        { name: "编码", prop: "code", width: 50 },
        { name: "名称", prop: "name" },
        { name: "其他名称", prop: "otherName" },
        { name: "类型", prop: "type" },
        { name: "有效状态", prop: "state" },
        { name: "操作时间", prop: "createTime" },
        { name: "备注", prop: "remark" }
      ],
      tableRows2: [
        { name: "项目名称", prop: "costName", width: 70 },
        { name: "项目序号", prop: "costId", width: 50 },
        { name: "适用对象", prop: "ruteLmtSpc" },
        { name: "类别", prop: "type" },
        { name: "收费方式", prop: "costType" },
        { name: "收费次数", prop: "costCnt" },
        { name: "计次方式", prop: "cntType" },
        { name: "用药频率", prop: "frquId" }
      ],

      // 树形菜单数据
      elTree: [
        {
          label: '全部',
          path: '',
          title: '',
          icon: 'el-icon-news',
          children: [
            { label: '注射', id: '1' },
            { label: '输液', id: '2' },
            { label: '口服', id: '3' },
            { label: '外用', id: '4' },
            { label: '输血', id: '5' },
            { label: '其他', id: '6' }
          ]
        }
      ],

      tableData: [],
      tableData2: [],
      userInfo: []
    };
  },

  async mounted() {
    await this.loadData();
    this.projectOptions = this.$store.getters['preload/getChargingPriceOptions'] || [];
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
  },

  methods: {
    // 重置对照表单（新增/编辑）
    resetAddRelevanceForm() {
      this.cosruteAddForm = getEmptyCosruteAddForm();
      this.cosruteEditForm = getEmptyCosruteEditForm();
    },

    handleCloseAddRelevance() {
      this.resetAddRelevanceForm();
      this.addDialogVisible = false;
      this.editDialogVisible = false;
    },

    handleShowRow(row) {
      // 保留空方法，原有逻辑
    },

    handleClickEdit(row) {
      this.cosruteTitel = "编辑给药方式";
      this.cosruteForm = JSON.parse(JSON.stringify(row));
      this.addCosruteDialogVisible = true;
    },

    async handleSelCode() {
      const res = await getMedicationFrequency();
      this.cosruteForm.code = res.data[res.data.length - 1]?.id + 1 || 1;
    },

    handleConvertingPinyin() {
      this.cosruteForm.pyCode = generatePinyinCode(this.cosruteForm.name);
    },

    handleCloseAddCosrute() {
      this.cosruteForm = getEmptyCosruteForm();
      this.addCosruteDialogVisible = false;
    },

    async addCosruteForm() {
      const valid = await this.$refs.cosruteFormRef.validate();
      if (!valid) return;

      await withLoading(this, '数据提交中...')(async () => {
        if (this.cosruteForm.id == null) {
          const res = await addCosruteForm(this.cosruteForm);
          if (res.code === 200) {
            await this.loadData();
            this.addCosruteDialogVisible = false;
          } else {
            this.$message.error(res.message);
          }
        } else {
          const res = await editCosruteForm(this.cosruteForm);
          if (res.code === 200) {
            await this.loadData();
            this.addCosruteDialogVisible = false;
          } else {
            this.$message.error(res.message);
          }
        }
      });
    },

    handleChargeNumberCorrect() {
      if (this.cosruteAddForm.costCnt <= 0) {
        this.cosruteAddForm.costCnt = null;
      }
    },

    handleRowClick(row) {
      this.$refs.myTable.setCurrentRow(row);
      const table = this.$el.querySelector('.el-table__body');
      if (table) {
        table.querySelectorAll('tr').forEach(tr => {
          tr.classList.remove('perm-highlight');
        });
        event.currentTarget.classList.add('perm-highlight');
      }
      this.selectedRow = row;
    },

    async handleEdit() {
      this.editDialogVisible = true;
      this.cosruteEditForm = { ...this.selectedRow };
    },

    formatColumn(row, prop) {
      const value = row[prop];
      switch (prop) {
        case 'type':
          return this.mapToLabel(value, this.typeOptions);
        case 'cntType':
          return this.mapToLabel(value, this.countTypeOptions);
        case 'costType':
          return this.mapToLabel(value, this.costTypeOptions);
        case 'ruteLmtSpc':
          return this.mapToLabel(value, this.applyTargetOptions);
        default:
          return value;
      }
    },

    mapToLabel(value, options) {
      if (value === undefined || value === null) return '';
      const found = options.find(item => item.id == value);
      return found ? found.label : value;
    },

    async handleAddData() {
      if (!this.cosruteAddForm.costId) {
        this.$message.warning('请选择项目');
        return;
      }

      await withLoading(this, '数据提交中...')(async () => {
        this.cosruteAddForm.ruteId = this.contrastItemForm.id;
        const projectName = this.projectOptions.find(item => item.id === this.cosruteAddForm.costId)?.name || '';
        const newItem = {
          ...this.cosruteAddForm,
          costName: projectName || `未知项目(ID: ${this.cosruteAddForm.costId})`
        };

        const res = await addCosrute(newItem);
        if (res.code === 200) {
          newItem.id = res.data;
          this.addDialogVisible = false;
          // 刷新列表
          const cosrute = await getCosruteItemData({ id: newItem.ruteId });
          this.tableData2 = cosrute.data;
        } else {
          this.$message.error(res.message);
        }
        this.resetAddRelevanceForm();
      });
    },

    async handleEditData() {
      if (!this.cosruteEditForm.costId) {
        this.$message.warning('请选择项目');
        return;
      }

      await withLoading(this, '数据提交中...')(async () => {
        this.cosruteEditForm.ruteId = this.contrastItemForm.id;
        const projectName = this.projectOptions.find(item => item.id === this.cosruteEditForm.costId)?.name || '';
        const newItem = {
          ...this.cosruteEditForm,
          costName: projectName || `未知项目(ID: ${this.cosruteEditForm.costId})`
        };

        const res = await updateCosrute(newItem);
        if (res.code === 200) {
          const index = this.tableData2.findIndex(item => item.id === this.cosruteEditForm.id);
          if (index !== -1) {
            this.$set(this.tableData2, index, { ...newItem });
          }
          this.editDialogVisible = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleAdd() {
      this.cosruteAddForm = getEmptyCosruteAddForm();
      this.addDialogVisible = true;
    },

    async loadData() {
      const res = await getMedicationFrequency({
        type: this.typeSelect == null ? null : this.typeSelect,
        name: this.searchValue === '' ? '' : this.searchValue
      });
      if (res.code === 200) {
        this.tableData = res.data;
        this.totalSize = res.data.totalSize;
        this.pageSize = res.data.pageSize;
      } else {
        this.$message.error(res.message);
      }
    },

    handleNodeClick(data) {
      this.typeSelect = data.id;
      this.loadData();
    },

    async handleDelete() {
      if (!this.selectedRow) {
        this.$message.warning("请选中数据再进行操作");
        return;
      }

      await this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(() => {});

      await withLoading(this, '删除中...')(async () => {
        const res = await deleteCosrute({ id: this.selectedRow.id });
        if (res.code === 200) {
          this.tableData2 = this.tableData2.filter(item => item.id !== this.selectedRow.id);
          this.selectedRow = null;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    async handleClick(val) {
      const res = await getCosrute({ id: val.id });
      this.tableData2 = res.data;
      this.contrastItemForm = JSON.parse(JSON.stringify(val));
      this.watch = '项目对照';
      this.dialogVisible = true;
    },

    handleClose(done) {
      this.tableData2 = [];
      this.resetAddRelevanceForm();
      this.addDialogVisible = false;
      this.dialogVisible = false;
    },

    handClick(i) {
      switch (i) {
        case 0:
          this.loadData();
          break;
        case 1:
          this.cosruteTitel = "新增给药方式";
          this.addCosruteDialogVisible = true;
          break;
      }
    },

    handleCommand(command) {
      switch (command) {
        case 'a':
          this.DropDownedName = '可用';
          break;
        case 'b':
          this.DropDownedName = '禁用';
          break;
          // 其他 case 为空
      }
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },

    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 288;
    },

    // 以下方法已移除（未使用）：aa, getditc, columnWidth, inputLabel, nowDateTime
  }
};
</script>
<style lang="less" scoped>
.el-table :deep(.perm-highlight) {
  background-color: #000 !important;
}

.el-table :deep(.perm-highlight) > td {
  background-color: transparent !important;
}

/* 覆盖Element默认高亮色 */
.el-table :deep(.current-row) {
  background-color: #000 !important;
}


.el-select-dropdown__item {
  padding: 6px 10px;
  font-size: 12px;
  line-height: 20px;
}

.el-select-dropdown__empty {
  padding: 8px 0; /* 空状态间距 */
  font-size: 12px;
}

.transparent-btn-group {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.transparent-btn {
  background-color: transparent !important;
  border: none !important;
  color: white !important; /* 图标设为白色 */
  padding: 6px 8px !important;
  font-size: 14px !important;
}

.transparent-btn:hover {
  background-color: rgba(255, 255, 255, 0.2) !important; /* 悬停效果 */
}

.transparent-btn:active {
  transform: scale(0.95);
}

.table-container {
  width: 100%; /* 跟随弹窗宽度 */
  padding: 0;
  margin: 0;
}

.table-header {
  background-color: #39648f; /* 深蓝色，与图片一致 */
  color: white;
  padding: 3px 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px 4px 0 0;

}

.header-title {
  font-size: 16px;
  font-weight: bold;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.table {
  margin-top: 0;
  width: 100%;
}

.footer-actions {
  margin-top: 15px;
  text-align: right;
}


// 穿透
/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

/deep/ .el-icon-arrow-left:before {
  content: "\e67d";
  font-size: 18px;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn {
  top: 12px;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close:hover {
  color: #00007f;
}

/deep/ .el-dialog__header {
  background-color: #39648f;
  padding: 8px;
}

/deep/ .el-dialog__body {
  padding: 0 20px 0 20px;
  border: 1px solid #efefef;
  padding: 8px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-descriptions {
  font-size: 12px !important;
}

/deep/ .el-descriptions-item__container {
  display: flex !important;
  // align-items: center !important;
  padding-top: 12px !important;
}

/deep/ .el-descriptions-item__label:not(.is-bordered-label) {
  padding-left: 0;
  width: 66px;
  display: flex;
  justify-content: right;
}

/deep/ .el-color-picker__icon, .el-input, .el-textarea {
  width: 100%;
}

// content
.MedicenCata {
  height: 100%;
  width: 100%;
  // header
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    // justify-content: space-evenly;
    // icon
    .header-icon {
      display: flex;
      align-items: center;
    }

  }

  // main
  .main {
    width: 100%;
    margin-left: 8px;
    display: flex;
    justify-content: left;
    overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
    // left
    .main-left {
      .custom-tree {
        max-height: 100%; /* 设置树形菜单的最大高度为父容器的100% */
        overflow-y: auto; /* 当内容超出设定高度时显示滚动条 */
      }

      /deep/ .el-tree-node__content {
        height: 40px;
        padding-left: 0 !important;
      }

      /deep/ .el-tree-node__label {
        font-size: 12px;
      }

      width: 10%;
      height: 100%;
    }

    // right
    .main-right {
      width: 85%;
      height: 100%;
      // alert
      .addmessagesBox {
        .tabs {
          padding: 12px;
          border: 1px solid #f8f8f8;
          background-color: #fefefe;

          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
            // background-color: indianred;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
          font-weight: bold;
        }

        /deep/ .el-table {
          font-size: 12px;
        }
      }

      // icon
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
          // width: 240px;
          // background-color: #00557f;
        }

        .main-icon-b {
          margin-left: 28px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
            // background-color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        // c
        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      // table
      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .table {
        padding: 12px;
      }
    }
  }

  // feet
  .feet {

    // alert
    .messagesBox {
      .tabs {

        /deep/ .el-form-item__content {
          display: flex;

          span {
            font-size: 12px;
          }
        }

        .oneLine {
          width: 524px;
          // background-color: indianred;
        }

        .oneLineBox {
          display: flex;
          // 循环子按钮
        }
      }

      /deep/ .el-dialog__title {
        font-size: 12px;
      }

      /deep/ .el-table {
        font-size: 12px;
      }
    }
  }

}
</style>